import { keyframes } from 'styled-components';

const pulseSmall = keyframes`
  0% {
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.3), 0 0 0 10px rgba(0, 0, 0, 0.05),
      0 0 0 10px rgba(255, 255, 255, 0.05);
  }
  40% {
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.3), 0 0 0 10px rgba(0, 0, 0, 0.05),
      0 0 0 20px rgba(255, 255, 255, 0.15);
  }
  100% {
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.3), 0 0 0 10px rgba(0, 0, 0, 0.05),
      0 0 0 30px rgba(255, 255, 255, 0);
  }
`;

export default pulseSmall;



// WEBPACK FOOTER //
// ./src/helpers/animPulseSmall.js